import { useIsNewSubway } from '../hooks/useIsNewSubway';
import { AddAdGroupOld } from './AddAdGroupOld';
import { StyledSubwayAddGroup } from './styles';
import { AddAdGroupProps } from './types';

export const AddAdGroup = (props: AddAdGroupProps) => {
  const isNewSubway = useIsNewSubway();

  if (!isNewSubway) {
    return <AddAdGroupOld {...props} />;
  }

  return <StyledSubwayAddGroup {...props} />;
};
